import { VERIFY_RESEND } from '../actionTypes'

export const verifyResend = (uuid: string) => ({
  type: VERIFY_RESEND.name,
  api: {
    url: 'user/verify_resend',
    data: { uuid },
  },
})
